<template>
  <vxe-modal v-model="visible" :loading="loading" title="title.inboundScan" type="confirm" width="40%" @confirm="confirm">
    <vxe-form ref="form" :data="view" border span="12" title-align="center" title-background>
      <vxe-form-item field="container.no" title="business.label.containerNo"/>
      <vxe-form-item field="sourceLocation.no" title="business.label.sourceLocation"/>
      <vxe-form-item :item-render="{name:'VxeInput',events:{click:()=>this.onStorageRoomSelect(),clear:()=>this.onStorageRoomChange([])}}" field="storageRoom.name" title="business.label.targetStorageRoom"/>
      <vxe-form-item :item-render="{name:'VxeInput',events:{click:()=>this.onLocationSelect(),clear:()=>this.onLocationChange([])}}" field="targetLocation.no" title="business.label.targetLocation"/>
      <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
      <location-modal ref="locationModal" @change="onLocationChange"/>
    </vxe-form>
  </vxe-modal>
</template>

<script>
import { post } from '@/api/Api'
import api from '@/api'
import { ContainerCommand } from '@/api/dto/command/ContainerCommand'
import { Container } from '@/api/dto/common/Container'
import { Location } from '@/api/dto/common/Location'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'

export default {
  components: { LocationModal, StorageRoomModal },
  data() {
    return {
      visible: false,
      loading: false,
      view: new ContainerCommand()
    }
  },
  methods: {
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open()
    },
    onStorageRoomChange(values) {
      this.view.storageRoom = new StorageRoom(values[0])
      this.view.targetLocation = new Location()
    },
    onLocationSelect() {
      if (this.view.storageRoom.isNew()) {
        return this.$message.warning(this.$t('business.label.storageRoom') + this.$t('message.cannotBeEmpty'))
      }
      this.$refs.locationModal.open({ 'storageRoom.id': this.view.storageRoom.id, locationType: 5, locationStatus: 1 })
    },
    onLocationChange(values) {
      this.view.targetLocation = new Location(values[0])
    },
    open(args) {
      this.visible = true
      if (args) {
        this.view.container = new Container(args.container)
        if (args.sourceLocation) {
          this.view.sourceLocation = new Location(args.sourceLocation)
        }
        if (args.targetLocation) {
          this.view.targetLocation = new Location(args.targetLocation)
        }
        if (args.storageRoom) {
          this.view.storageRoom = new StorageRoom(args.storageRoom)
        }
      }
    },
    confirm() {
      this.loading = true
      const args = {
        'container.no': this.view.container.no,
        'location.no': this.view.targetLocation.no,
        storageRoomType: this.view.storageRoom.storageRoomType,
        tag: this.view.storageRoom.tag
      }
      post(api.containerScanAll, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>